import { useDisplay } from "vuetify";
import { computed, type ComputedRef } from "vue";

// Interface to define the structure of the screen size composable
interface ScreenSize {
    currentSize: ComputedRef<string>;
    smAndDown:Ref<boolean, boolean>;
}

/**
 * Composable to manage screen size breakpoints
 * Provides a reactive property to get the current screen size
 */
export const useScreenSize = (): ScreenSize => {
    const { xs, sm, md, lg, xl, smAndDown } = useDisplay();

    // Computed property to get the current breakpoint
    const currentSize: ComputedRef<string> = computed(() => {
        if (xs.value) return "xs"; // Extra Small
        if (sm.value) return "sm"; // Small
        if (md.value) return "md"; // Medium
        if (lg.value) return "lg"; // Large
        if (xl.value) return "xl"; // Extra Large
        return "unknown"; // Fallback
    });

    return { currentSize, smAndDown };
};
